export const linkPrefix = '/react-gravatar'



/** WEBPACK FOOTER **
 ** ../gatsby-browser.js
 **/